import { apiClient } from './client';
import type {
  CelebrationInvitationSummary,
  CelebrationInvitationType,
  InviteCelebrantRequest,
  InviteTeamMemberRequest,
} from '@/types/celebration-invitation.types';

class CelebrationInvitationService {
  async getCelebrationInvitations(
    celebrationId: number,
    type?: CelebrationInvitationType,
  ): Promise<CelebrationInvitationSummary[]> {
    const response = await apiClient.get(`/celebrations/${celebrationId}/invitations`, {
      params: type ? { type } : undefined,
    });
    return response.data.data || [];
  }

  async inviteTeamMember(
    celebrationId: number,
    request: InviteTeamMemberRequest,
  ): Promise<CelebrationInvitationSummary> {
    const response = await apiClient.post(`/celebrations/${celebrationId}/invitations/team-members`, request);
    return response.data.data;
  }

  async inviteCelebrant(
    celebrationId: number,
    request: InviteCelebrantRequest,
  ): Promise<CelebrationInvitationSummary> {
    const response = await apiClient.post(`/celebrations/${celebrationId}/invitations/celebrants`, request);
    return response.data.data;
  }

  async getMyInvitations(): Promise<CelebrationInvitationSummary[]> {
    const response = await apiClient.get('/celebration-invitations/mine');
    return response.data.data || [];
  }

  async respondToInvitation(
    invitationId: number,
    decision: 'accepted' | 'declined',
  ): Promise<CelebrationInvitationSummary> {
    const response = await apiClient.post(`/celebration-invitations/${invitationId}/respond`, { decision });
    return response.data.data;
  }
}

export const celebrationInvitationService = new CelebrationInvitationService();
